/* Cuándo lo tiene · Imprimirlo
 *
 * LA FECHA ES LA PRIMERA PREGUNTA QUE HACE UN CLIENTE. El precio es la
 * segunda. Por eso esto va arriba del todo de la ficha y no en una pestaña.
 *
 * Y es donde de verdad se le gana a la competencia: ellos ofrecen cinco días
 * en su producto "urgente"; aquí lo normal son tres o cuatro y con recargo
 * está mañana. Callarlo era regalar la única ventaja clara que hay.
 *
 * REGLA DE ORO: se promete por lo ALTO. Más vale decir el miércoles y que
 * llegue el martes que al revés. Un plazo incumplido en una camiseta de
 * evento no se arregla con una devolución.
 *
 * Todos los números vienen de la configuración de la ficha:
 *
 *   produccion  [min, max] días laborables en montar un pedido NORMAL, de los
 *               que caben en un día.
 *   porDia      cuántas impresiones entran en una jornada, contando que el
 *               taller también hace mostrador y encargos de fuera de la web.
 *               Cada jornada de más suma un día al plazo. Se cuentan
 *               IMPRESIONES, no prendas: 50 camisetas con logo delante y
 *               espalda son 100 pasadas de plancha, no 50.
 *   transporte  días del mensajero hasta la puerta.
 *   corte       hora a partir de la cual el día de hoy ya no cuenta como día
 *               de producción (la misma que la de urgente.js).
 *   zona        a qué destino se refiere el plazo. No se puede prometer lo
 *               mismo a Girona que a Canarias, así que se dice cuál es.
 *
 * Va en su propio fichero porque los plazos cambian con la carga de trabajo y
 * con el transportista, y eso no debería obligar a tocar el configurador.
 */
(function () {
  'use strict';

  var DIA = 86400000;

  /* LOS FESTIVOS. Xavi: «ten en cuenta que solo trabajo de lunes a viernes» y
   * «vamos con los festivos de Cerdanyola del Vallès y de Catalunya». Un día
   * festivo no es día de taller ni de mensajero, igual que un sábado.
   *
   * Fuentes (comprobadas el 26/09/2026):
   *   · Catalunya 2026 y 2027: calendario oficial del Govern (DOGC).
   *   · Cerdanyola 2026: el pleno del Ayuntamiento aprobó el 4 de mayo
   *     (Roser de Maig) y el 11 de noviembre (Sant Martí).
   *   · Cerdanyola 2027: SIN PUBLICAR todavía. Cuando el pleno los apruebe
   *     —suele ser a mitad de año— hay que añadirlos aquí.
   *
   * Solo cuentan los que caen entre semana, pero están todos para que la
   * lista se pueda cotejar de un vistazo con el calendario oficial. Se puede
   * añadir alguno más desde la ficha con `festivos` en la configuración (un
   * cierre por vacaciones, por ejemplo). */
  var FESTIVOS = [
    // Catalunya 2026
    '2026-01-01', '2026-01-06', '2026-04-03', '2026-04-06', '2026-05-01', '2026-06-24',
    '2026-08-15', '2026-09-11', '2026-10-12', '2026-11-01', '2026-12-06', '2026-12-08',
    '2026-12-25', '2026-12-26',
    // Cerdanyola del Vallès 2026 (locales)
    '2026-05-04', '2026-11-11',
    // Catalunya 2027
    '2027-01-01', '2027-01-06', '2027-03-26', '2027-03-29', '2027-05-01', '2027-06-24',
    '2027-09-11', '2027-10-12', '2027-11-01', '2027-12-06', '2027-12-08', '2027-12-25'
    // Cerdanyola 2027: pendientes de aprobar
  ];
  var extra = {};

  function clave(f) {
    var m = f.getMonth() + 1, d = f.getDate();
    return f.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (d < 10 ? '0' : '') + d;
  }
  function esFestivo(f) {
    var k = clave(f);
    return FESTIVOS.indexOf(k) !== -1 || !!extra[k];
  }
  // los que añade la ficha (vacaciones, un cierre) se suman a los oficiales
  function usar(cfg) {
    extra = {};
    ((cfg && cfg.festivos) || []).forEach(function (k) { extra[k] = 1; });
  }

  function laborable(f) { var d = f.getDay(); return d !== 0 && d !== 6 && !esFestivo(f); }

  /* Suma días LABORABLES. Con n = 0 devuelve el primer día laborable desde la
     fecha dada, que es lo que hace falta cuando se pide un sábado. */
  function sumar(f, n) {
    var d = new Date(f.getTime());
    while (!laborable(d)) d = new Date(d.getTime() + DIA);
    for (var i = 0; i < n; i++) {
      do { d = new Date(d.getTime() + DIA); } while (!laborable(d));
    }
    return d;
  }

  /* El navegador escribe "lunes, 28 de septiembre" con coma. Fuera: aquí la
     fecha va dentro de una frase y esa coma la parte en dos. */
  function fecha(f, conMes) {
    return f.toLocaleDateString('es-ES', conMes
      ? { weekday: 'long', day: 'numeric', month: 'long' }
      : { weekday: 'long', day: 'numeric' }).replace(',', '');
  }

  function mismoDia(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();
  }

  /* El día en que empieza a contar la producción: hoy si aún da tiempo, y si
     no el siguiente laborable. */
  function arranque(cfg, ahora) {
    var corte = cfg.corte != null ? cfg.corte : 12;
    var base = ahora;
    if (!laborable(ahora) || ahora.getHours() >= corte) {
      base = sumar(new Date(ahora.getTime() + DIA), 0);
    }
    return base;
  }

  /* Los días que suma la CANTIDAD. Un pedido de 5 camisetas y uno de 300 no
     pueden prometer la misma fecha: el segundo son varios días de taller.
     Se cuentan impresiones, que es lo que de verdad ocupa la máquina. */
  function diasPorCantidad(cfg, impresiones) {
    var porDia = cfg.porDia || 0;
    if (!porDia || !impresiones) return 0;
    return Math.max(0, Math.ceil(impresiones / porDia) - 1);
  }

  /* [primera, última] fecha de entrega. En urgente la producción es cero: sale
     hoy mismo en la recogida del mensajero. */
  function rango(cfg, urgente, ahora, impresiones, unidades) {
    usar(cfg);
    ahora = ahora || new Date();
    var base = arranque(cfg, ahora);
    var t = cfg.transporte != null ? cfg.transporte : 1;
    var p = urgente ? [0, 0] : (cfg.produccion || [3, 5]);
    var mas = urgente ? 0 : diasPorCantidad(cfg, impresiones);
    /* PEDIDOS GRANDES (Xavi, 01/10): a partir de cierto número de hojas el pedido sale al proveedor (vinilo UV de 1 a 3 días +
       CTT hasta aquí + reenvío), con su propio plazo, y ya no se suma un día por cada 30 hojas.
       cfg.tramosHojas = [{desde: hojas, produccion: [min, max]}, ...] */
    if (!urgente && cfg.tramosHojas && impresiones > 0) {
      cfg.tramosHojas.forEach(function (t) {
        if (impresiones >= t.desde) { p = t.produccion; mas = 0; }
      });
    }
    /* PRODUCTOS QUE IMPRIME MIDOCEAN (Xavi, 06/10): el plazo lo marca la CANTIDAD DE PRENDAS, no las pasadas de plancha del taller.
       cfg.tramosUds = [{desde: unidades, produccion: [min, max]}, ...] (días laborables, ya con margen). Con 0 unidades vale el primero. */
    if (!urgente && cfg.tramosUds && cfg.tramosUds.length) {
      p = cfg.tramosUds[0].produccion; mas = 0;
      cfg.tramosUds.forEach(function (tu) { if ((unidades || 0) >= tu.desde) p = tu.produccion; });
    }
    return [sumar(base, p[0] + mas + t), sumar(base, p[1] + mas + t)];
  }

  /* Los plazos en DÍAS (no en fechas), para el PDF del presupuesto (Xavi, 24/10/2026: «no pongas fecha de entrega, pon días desde que se aprueba el
     boceto»): producción [mín, máx] en días laborables desde que se aprueba el boceto + días de transporte. Misma lógica que `rango`. */
  function dias(cfg, urgente, impresiones, unidades) {
    var t = cfg.transporte != null ? cfg.transporte : 1;
    var p = urgente ? [0, 0] : (cfg.produccion || [3, 5]).slice();
    var mas = urgente ? 0 : diasPorCantidad(cfg, impresiones);
    if (!urgente && cfg.tramosHojas && impresiones > 0) {
      cfg.tramosHojas.forEach(function (th) { if (impresiones >= th.desde) { p = th.produccion.slice(); mas = 0; } });
    }
    if (!urgente && cfg.tramosUds && cfg.tramosUds.length) {
      p = cfg.tramosUds[0].produccion.slice(); mas = 0;
      cfg.tramosUds.forEach(function (tu) { if ((unidades || 0) >= tu.desde) p = tu.produccion.slice(); });
    }
    return { prod: [p[0] + mas, p[1] + mas], transporte: t };
  }
  function textoDias(cfg, urgente, impresiones, unidades) {
    if (!cfg) return '';
    var d = dias(cfg, urgente, impresiones, unidades), n = function (x) { return x + (x === 1 ? ' día' : ' días'); };
    var prod = d.prod[0] === d.prod[1] ? n(d.prod[0]) + ' laborables' : 'de ' + d.prod[0] + ' a ' + d.prod[1] + ' días laborables';
    var t = d.transporte ? ', más ' + n(d.transporte) + ' de transporte' + (cfg.zona ? ' (' + cfg.zona + ')' : '') : '';
    return urgente ? 'Plazo: entrega urgente, sale el mismo día en que se aprueba el boceto' + t + '.'
      : 'Plazo de entrega: ' + prod + ' desde que se aprueba el boceto' + t + '.';
  }

  /* LOS TRES PLAZOS DE IMPRENTA (Xavi, 02/10): express 2-3 días, normal 4-5 y económico 6-7 días laborables de
     entrega. Se cuentan sobre la producción de siempre (hoy normal = producción 2-3 + 1 de transporte = 3-4 días):
     express -1, normal +1, económico +3. Los pedidos grandes (tramosHojas) corren igual. SIEMPRE ESTIMADA. */
  var OFFSET = { express: -1, normal: 1, eco: 3 };
  function rangoPlazo(cfg, plazo, ahora, impresiones) {
    var o = OFFSET[plazo] || 0, c2 = {};
    for (var k in cfg) c2[k] = cfg[k];
    c2.produccion = (cfg.produccion || [3, 5]).map(function (n) { return n + o; });
    c2.tramosHojas = (cfg.tramosHojas || []).map(function (t) {
      return { desde: t.desde, produccion: t.produccion.map(function (n) { return n + o; }) };
    });
    return rango(c2, false, ahora, impresiones);
  }
  function textoPlazo(cfg, plazo, ahora, impresiones) {
    if (!cfg) return '';
    usar(cfg);
    var r = rangoPlazo(cfg, plazo, ahora, impresiones), zona = cfg.zona ? ' · ' + cfg.zona : '';
    return mismoDia(r[0], r[1])
      ? '<b>Entrega estimada el ' + fecha(r[0], true) + '</b>' + zona
      : '<b>Entrega estimada entre el ' + fecha(r[0], false) + ' y el ' + fecha(r[1], true) + '</b>' + zona;
  }

  function texto(cfg, urgente, ahora, impresiones, unidades) {
    if (!cfg) return '';
    usar(cfg);
    ahora = ahora || new Date();
    var r = rango(cfg, urgente, ahora, impresiones, unidades);
    /* «MAÑANA» ES MAÑANA DE VERDAD, EL DÍA SIGUIENTE DEL CALENDARIO. Antes se saltaba
       el fin de semana (el siguiente laborable) y un pedido hecho un viernes por la
       mañana decía «Lo tienes mañana, lunes 5»: nadie lo entrega un sábado, y
       el cliente lo leía como entrega al día siguiente (Xavi, 02/10). */
    var manana = new Date(ahora.getTime() + DIA);
    var zona = cfg.zona ? ' · ' + cfg.zona : '';

    if (urgente) {
      return mismoDia(r[0], manana)
        ? '<b>Lo tienes mañana</b>, ' + fecha(r[0], false) + zona
        : '<b>Lo tienes el ' + fecha(r[0], true) + '</b>' + zona;
    }
    return mismoDia(r[0], r[1])
      ? '<b>Entrega el ' + fecha(r[0], true) + '</b>' + zona
      : '<b>Entrega entre el ' + fecha(r[0], false) + ' y el ' + fecha(r[1], true) +
        '</b>' + zona;
  }

  /* Se pinta sola y se entera de la urgencia escuchando la casilla, sin que el
     configurador tenga que avisarla. Así los plazos se cambian aquí y nada
     más. */
  function montar(raiz) {
    var caja = raiz.querySelector('[data-entrega]');
    var cfgEl = raiz.querySelector('[data-ropa-config]');
    if (!caja || !cfgEl) return;
    var cfg = (JSON.parse(cfgEl.textContent) || {}).entrega;
    if (!cfg) { caja.hidden = true; return; }

    var pinta = function () {
      var c = raiz.querySelector('[data-urg]');
      /* La cantidad se le pregunta al configurador si está montado. Así esto
         sigue funcionando en una ficha que no lo tenga: sin cantidad, el plazo
         es el de un pedido normal. */
      var r = raiz._ropa, imp = 0;
      if (r && r.resumen) {
        imp = (r.resumen.unidades || 0) * Math.max(1, (r.elegidas || []).length);
      }
      caja.innerHTML = texto(cfg, !!(c && c.checked), null, imp, (r && r.resumen && r.resumen.unidades) || 0);
      caja.hidden = false;
    };
    pinta();
    /* La casilla de urgente se repinta entera cuando cambia de tramo, así que
       no vale con engancharse a ella: se escucha todo el bloque. Y la cantidad
       cambia escribiendo, que no dispara "change" hasta salir del campo. */
    raiz.addEventListener('input', function () { setTimeout(pinta, 0); });
    raiz.addEventListener('change', function () { setTimeout(pinta, 0); });
    raiz.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-urgente]')) {
        setTimeout(pinta, 0);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-ropa]').forEach(montar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  window.Entrega = { texto: texto, dias: dias, textoDias: textoDias, rango: rango, rangoPlazo: rangoPlazo, textoPlazo: textoPlazo, sumar: sumar, laborable: laborable, FESTIVOS: FESTIVOS };
})();